import {
    Album,
    PayloadGetListAlbum,
    ResponseGetListAlbum,
    ResponseGetListArtist,
} from '@lib/domain/streamingpal';
import { AppThunk } from '@lib/state/types';

import { StreamingPalActions } from '@lib/state/_actions';
import * as reducers from '@lib/state/reducers';
import { StreamingpalState, Track } from './types';

export const getListArtist: (
    name: string,
) => AppThunk<Promise<ResponseGetListArtist>> =
    (name) =>
    async (_dispatch, _getState, container): Promise<ResponseGetListArtist> => {
        // create order
        const res: ResponseGetListArtist =
            await container.cradle.streamingpalRepository.getListArtist(name);

        return res;
    };

// eslint-disable-next-line
export const getSpotifyProfile: (userId: string) => AppThunk<Promise<any>> =
    (
        userId,
        // eslint-disable-next-line
    ) =>
    async (dispatch, _getState, container): Promise<any> => {
        // create order
        const res =
            await container.cradle.streamingpalRepository.getProfileUser(
                userId,
            );
        const { errorHttp } = res;
        if (!errorHttp) {
            const userInfo = {
                name: res.name,
                image: res.images[0]?.url || '',
                id: res.id,
                type: res.type,
                url: res.external_urls.spotify,
            };
            await dispatch(StreamingPalActions.setUserInfo(userInfo));
        }
        return res;
    };

export const getListAlbum: (
    payload: PayloadGetListAlbum,
) => AppThunk<Promise<ResponseGetListAlbum>> =
    (payload) =>
    async (dispatch, _getState, container): Promise<ResponseGetListAlbum> => {
        // create order
        const res: ResponseGetListAlbum =
            await container.cradle.streamingpalRepository.getListAlbum(payload);
        const { errorHttp } = res;
        if (!errorHttp) {
            const listAlbum = res.items;
            dispatch(StreamingPalActions.setListAlbum(listAlbum));
        }
        return res;
    };

export const getListTrackByAlbum: (
    userId: string,
) => AppThunk<Promise<Track[]>> =
    (albumId) =>
    async (dispatch, _getState, container): Promise<Track[]> => {
        // create order
        const res: Track[] =
            await container.cradle.streamingpalRepository.getListTrackByAlbum(
                albumId,
            );
        dispatch(StreamingPalActions.setTracks(res));
        return res;
    };

export const getLinkAlbumByLink: (
    url: string,
) => AppThunk<Promise<ResponseGetListAlbum>> =
    (url) =>
    async (dispatch, _getState, container): Promise<ResponseGetListAlbum> => {
        // @ts-ignore
        const rootState: StreamingpalState =
            _getState()[reducers.StreamingPalReducer.stateKey];
        const albums = rootState.listAlbum;
        const res: ResponseGetListAlbum =
            await container.cradle.streamingpalRepository.getListAlbumByLink(
                url,
            );
        const { errorHttp } = res;
        if (!errorHttp) {
            const listAlbum = [...albums, ...res.items];
            dispatch(StreamingPalActions.setListAlbum(listAlbum));
        }
        return { ...res, items: [...albums, ...res.items] as Album[] };
    };

const StreamingpalsThunks = {
    getListArtist,
    getSpotifyProfile,
    getListAlbum,
    getListTrackByAlbum,
    getLinkAlbumByLink,
};

export default StreamingpalsThunks;
